import Grid from '@material-ui/core/Grid';
import { Button, TextField } from '@material-ui/core';
import LoadingSpinner from '../loading-spinner';
import React from 'react';
import { FormikProps } from 'formik';
import { TReport } from '../../../definitions';
import { editReportStyles } from './styles';

export default function EditReportForm(props: FormikProps<TReport>) {
  const classes = editReportStyles();

  const {
    values,
    errors,
    touched,
    handleSubmit,
    handleChange,
    handleBlur,
    handleReset,
    isSubmitting
  } = props;

  const formikProps = (name: string, initialValue = '') => ({
    name: name,
    value: typeof values[name] !== 'undefined' ? values[name] : initialValue,
    onChange: handleChange,
    onBlur: handleBlur,
    error: touched[name] && Boolean(errors[name]),
    helperText: touched[name] ? errors[name] : ''
  });

  return (
    <form noValidate autoComplete="off" onSubmit={handleSubmit}>
      <Grid container spacing={2} direction="column">
        <Grid item>
          <TextField
            {...formikProps('name')}
            label="Report Name"
            type="text"
            variant="outlined"
            fullWidth={true}
          />
        </Grid>

        <Grid item>
          <TextField
            {...formikProps('link')}
            label="Report URL"
            type="text"
            variant="outlined"
            fullWidth={true}
          />
        </Grid>
      </Grid>
      <Grid container justify="flex-end" spacing={2}>
        <>
          <Grid item>
            <Button
              className={classes.margin}
              type="submit"
              variant="contained"
              size="large"
              fullWidth
              color="primary"
              disabled={isSubmitting}
            >
              {isSubmitting && <LoadingSpinner />}
              Update
            </Button>
          </Grid>

          <Grid item>
            <Button
              className={classes.margin}
              variant="outlined"
              size="large"
              color="secondary"
              fullWidth
              onClick={handleReset}
              disabled={isSubmitting}
            >
              Reset
            </Button>
          </Grid>
        </>

        {/*{error && (*/}
        {/*  <div>*/}
        {/*    <span className={classes.errorText}>{error.message}</span>*/}
        {/*  </div>*/}
        {/*)}*/}
      </Grid>
    </form>
  );
}
